"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperLogoMobile = exports.LogoLink = exports.NavRight = exports.NavLeft = exports.Drawer = exports.AppBarCustom = exports.MainContent = exports.ImageLogo = exports.ContentWrapper = exports.MainWrapper = exports.PageWrapper = exports.drawerWidth = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var colors_1 = require("@mui/material/colors");
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var react_router_dom_1 = require("react-router-dom");
var appBarHeight = 80;
exports.drawerWidth = 260;
exports.PageWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100vh;\n  position: relative;\n"], ["\n  height: 100vh;\n  position: relative;\n"])));
exports.MainWrapper = (0, styled_1.default)('div')(function () { return ({
    height: "calc(100% - ".concat(appBarHeight, "px)"),
    width: '100%',
    display: 'flex',
}); });
exports.ContentWrapper = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
exports.ImageLogo = styled_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 100%;\n  object-fit: contain;\n  aspect-ratio: 9/4;\n"], ["\n  height: 100%;\n  object-fit: contain;\n  aspect-ratio: 9/4;\n"])));
exports.MainContent = (0, styled_1.default)('main')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: "calc(100vh - ".concat(appBarHeight, "px)"),
            padding: '0 20px'
        },
        _b[theme.breakpoints.up('sm')] = {
            padding: '0 40px',
        },
        _b);
});
exports.AppBarCustom = (0, styled_1.default)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: appBarHeight,
        padding: '20px',
        borderBottom: "2px solid ".concat(colors_1.grey[100]),
    });
});
exports.Drawer = (0, styled_1.default)(Drawer_1.default)(function (_a) {
    var _b, _c;
    var theme = _a.theme, open = _a.open;
    return (_b = {
            transform: open ? 'translateX(0)' : "translateX(-100%)"
        },
        _b[theme.breakpoints.up('sm')] = {
            position: open ? 'relative' : 'fixed',
        },
        _b['& .MuiDrawer-paper'] = __assign({ position: 'relative', whiteSpace: 'nowrap', width: exports.drawerWidth, padding: !open ? 0 : '0 18px', transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }), boxSizing: 'border-box' }, (!open && (_c = {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(7)
            },
            _c[theme.breakpoints.up('sm')] = {
                width: theme.spacing(9),
            },
            _c))),
        _b);
});
exports.NavLeft = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 230px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n"], ["\n  width: 230px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n"])));
exports.NavRight = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  @media (min-width: 768px) {\n    gap: 20px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  @media (min-width: 768px) {\n    gap: 20px;\n  }\n"])));
exports.LogoLink = (0, styled_1.default)(react_router_dom_1.Link)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 300px;\n  height: 50px;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  @media (min-width: 768px) {\n    width: 240px;\n    display: flex;\n  }\n"], ["\n  width: 300px;\n  height: 50px;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  @media (min-width: 768px) {\n    width: 240px;\n    display: flex;\n  }\n"])));
exports.WrapperLogoMobile = styled_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 60px;\n  display: flex;\n  margin: 20px 0;\n"], ["\n  height: 60px;\n  display: flex;\n  margin: 20px 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
